import appGlobalScript from 'C:/Users/BeauBuxton/OneDrive - Herd Agency Limited/Documents/Dev New/Component Library/intravenous/src/global/app.ts';
export const globalScripts = appGlobalScript;
export const globalStyles = "";
